import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  ProceduresFetchParamsType,
  ProceduresLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';
import type {ContentType} from 'sweet-types';

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}

interface DashboardState {
  filters: ProceduresLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

const initialState: DashboardState = {
  filters: {} as ProceduresLocationParamsType,
  relations: {},
};

export const proceduresSlice = createSlice({
  name: 'procedures',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
    setProceduresFilters(
      state,
      action: PayloadAction<ProceduresFetchParamsType>
    ) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {toggleDashboardRelation, setProceduresFilters} =
  proceduresSlice.actions;

export const selectProcedureFilters = (state: DefaultRootState) =>
  state.procedures.filters;

export const selectProceduresRelations = (state: DefaultRootState) =>
  state.procedures.relations;
